const accountManagementStrings = {
  loginForm: {
    formBtnText: 'Login with Azure AD',
  },
};

export default accountManagementStrings;
